<template>
  <component
    :is="layout"
    class="layout"
    :class="layout"
  />
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  mounted() {
    Echo.join(`users`)
      .joining(async (user) => {
        await this.updateUserConnection({ user, active: true });

        console.log('join', user);
        if (this.profile.id === user) {
          await this.getProfile(user);

          console.log('profile', this.profile);
        }
      })
      .leaving(async user => {
        await this.updateUserConnection({ user, active: false });

        if (this.profile.id === user) {
          console.log('leave', user);
          await this.getProfile(user);
        }
      })
      .listen('UserLogout', async ({ user }) => {
        const { id } = user;
        console.log('UserLogout app.vue', id);

        await this.updateUserConnection({ user: id, active: false });

        if (this.profile.id === id) {
          await this.getProfile(id);
        }
      })
      .listen('UserLogin', async ({ user }) => {
        const { id } = user;
        console.log('UserLogin app.vue', id);

        await this.updateUserConnection({ user: id, active: true });

        if (this.profile.id === id) {
          await this.getProfile(id);
        }
      });
  },
  computed: {
    ...mapState('profiles', ['profile']),
    ...mapState("locale", ["locale"]),
    defaultLayout() {
      return "app";
    },
    layout() {
      return `${this.$route.meta.layout || this.defaultLayout}-layout`;
    }
  },
  methods: {
    ...mapActions('profiles', ['getProfile']),
    ...mapActions('auth', ['updateUserConnection']),
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
